class Config {
    constructor() {
        const apiServiceBaseUri = 'https://' + window.location.host + '/';

        this.apiServiceBaseUri = apiServiceBaseUri;
        this.mixiplyUri = 'https://mixiply.com/';
    }
}

const config = new Config();
export default config;